export var ShapeTypes;
(function (ShapeTypes) {
    ShapeTypes["STAR"] = "start";
    ShapeTypes["SQUARE"] = "square";
    ShapeTypes["CIRCLE"] = "circle";
    ShapeTypes["TRIANGLE"] = "triangle";
    ShapeTypes["PENTAGON"] = "pentagon";
    ShapeTypes["HEXAGON"] = "hexagon";
})(ShapeTypes || (ShapeTypes = {}));
